<template>
  <v-container fluid>
    <v-card elevation="0" max-width="550" class="mx-auto pa-4" outlined rounded>
      <v-row class="text-center">
        <v-carousel
          :continuous="false"
          :cycle="true"
          :show-arrows="false"
          hide-delimiter-background
          height="420"
          light
        >
          <v-carousel-item>
            <v-col cols="12">
              <v-img
                :src="require('../assets/amedlogo.png')"
                class="mb-4 mt-8"
                contain
                height="140"
              />
            </v-col>
            <v-col>
              <h2 class="font-weight-bold mb-3">โปรแกรมไทยสุข</h2>
              <p class="subheading font-weight-regular">
                เพื่อให้คนไทยสุขภาพดี มีความสุข<br/>แพลตฟอร์มการแข่งขันเพื่อส่งเสริมสุขภาพแบบออนไลน์
              </p>
            </v-col>
          </v-carousel-item>
          <v-carousel-item>
            <v-col cols="12">
              <v-img
                :src="require('../assets/simple7.png')"
                class="my-3"
                contain
                height="150"
              />
            </v-col>
            <v-col>
              <h2 class="font-weight-bold mb-3">Life’s Simple 7</h2>
              <p class="subheading font-weight-regular">
                “ทุกคนมีสุขภาพดีได้ด้วยตัวชี้วัด 7 อย่าง”
                <br />งานวิจัยที่ได้รับการรับรองโดยสมาคมโรคหัวใจสหรัฐอเมริกา
                พบว่าการปรับเปลี่ยนพฤติกรรมและวิถีชีวิตที่เหมาะสมโดยการปฏิบัติตามตัวชี้วัดง่าย
                ๆ รวม 7 อย่าง
                สามารถลดความเสี่ยงในการเสียชีวิตก่อนวัยอันควรได้ถึงร้อยละ 91
              </p>
            </v-col>
          </v-carousel-item>
          <v-carousel-item>
            <v-col cols="12">
              <v-img
                :src="require('../assets/doctor.png')"
                class="my-3"
                contain
                height="150"
              />
            </v-col>
            <v-col>
              <h2 class="font-weight-bold mb-3">
                การปรับเปลี่ยนพฤติกรรมและติดตามผล
              </h2>
              <p class="subheading font-weight-regular">
                โปรแกรมของเราช่วยให้สามารถติดตามดัชนีทั้ง 7 อย่าง คือ
                ปริมาณการออกกำลังกาย ปริมาณการบริโภคผักผลไม้ ดัชนีมวลกาย
                การสูบบุหรี่ ความดันโลหิต ค่าไขมันในเลือด และค่าน้ำตาลในเลือด
                ได้อย่างง่ายดาย และช่วยประเมินพร้อมให้คำแนะนำรายสัปดาห์
                เป็นผู้ช่วยส่วนตัวในการเฝ้าติดตามสุขภาพของท่านต่อไป
              </p>
            </v-col>
          </v-carousel-item>
        </v-carousel>
        <!-- <v-col class="mb-1" cols="12">
          <v-btn color="indigo" to="/login" dark>Login</v-btn>
        </v-col> -->
      </v-row>
      <v-row class="text-center">
        <v-col class="mb-1" cols="12">
          <phone-login-button normal></phone-login-button>
        </v-col>
      </v-row>
      <v-row class="text-center">
        <v-col class="mb-1" cols="12">
          <line-login-button normal></line-login-button>
        </v-col>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
    import LineLoginButton from '@/components/LineLoginButton'
    import PhoneLoginButton from '@/components/PhoneLoginButton'
    // import {
    //   lineConfig
    // } from '@/helpers/lineConfig';

    export default {
        data() {
            return {
                // clientId: '',
                // clientSecret: '',
                // callbackUri: ''
            }
        },
        components: {
            LineLoginButton,
            PhoneLoginButton
        },
        created() {
            // this.clientId = lineConfig.VUE_APP_LINE_CLIENT_ID
            // this.clientSecret = lineConfig.VUE_APP_LINE_CLIENT_SECRET
            // this.callbackUri = lineConfig.VUE_APP_LINE_CALLBACK_URL
        },

        methods: {
            // lineLogin() {
            //   const lineLoginUrl = `https://access.line.me/oauth2/v2.1/authorize?response_type=code&client_id=${this.clientId}&redirect_uri=${this.callbackUri}&state=12345abcde&scope=profile%20openid`;
            //   window.location.href = lineLoginUrl;
            // }
        }
    }

</script>